/*
  Align System guided builder.
  Reads real product/variant data injected by the section into
  window.SD_ALIGN_BUILDER_DATA (see align-system-builder.liquid) and drives
  a dynamic step-by-step wizard. The step sequence is NOT fixed - adding the
  Align™ Duvet Cover + Insert inserts extra steps for that product's own
  real options (cover: material -> color; insert: fill -> loft), then
  removes them again if the user goes back and picks "just the sheets".
  Cover/insert sizes are derived silently from the one bed-size question
  asked up front - never re-asked. All prices/variant IDs are read from real product
  data, never hardcoded. "Place Order" adds the selected real variants to
  the cart via the Ajax Cart API, then redirects straight to /checkout
  (skipping the cart page).
*/
(function () {
  var DATA = window.SD_ALIGN_BUILDER_DATA;
  if (!DATA) return;

  var FABRIC_PRODUCT = { sateen: DATA.sheetSateen, linen: DATA.sheetLinen, percale: DATA.sheetPercale };
  var FABRIC_NAME = { sateen: 'Organic Cotton Sateen', linen: 'European Linen', percale: 'Organic Cotton Percale' };
  var COVER_PRODUCT = { sateen: DATA.coverSateen, boucle: DATA.coverBoucle, waffle: DATA.coverWaffle, percale: DATA.coverPercale };
  var COVER_NAME = { sateen: 'Organic Cotton Sateen', boucle: 'Organic Cotton Boucle', waffle: 'Organic Cotton Waffle', percale: 'Organic Cotton Percale' };
  var PILLOW_PRODUCT = { regular: DATA.pillowRegular, quilted: DATA.pillowQuilted };
  var PILLOW_NAME = { regular: 'Organic Kapok Pillow', quilted: 'Organic Kapok Quilted Pillow' };
  var PROTECTOR = DATA.protector;
  var DUVET_INSERT = DATA.duvetInsert;

  var BED_TO_PILLOW_SIZE = { Twin: 'Standard', Full: 'Standard', Queen: 'Standard', King: 'King' };
  var BED_TO_PROTECTOR_SIZE = { Twin: 'Twin', Full: 'Full', Queen: 'Queen', King: 'King' };
  var BED_TO_COMBINED_SIZE = { Twin: 'Twin/Twin XL', Full: 'Full/Queen', Queen: 'Full/Queen', King: 'King/Cal King', 'Cal King': 'King/Cal King' };

  // ---------- real customer reviews (from the store's Loox export) ----------
  // Grouped by which real product they were left on - "sateenSheet"/
  // "sateenCover" pull from reviews tagged to the product's former handle
  // ("organic-lustre-*"), the same product under its old name. Only
  // Active-status reviews are included. r defaults to 5 when omitted.
  var REVIEWS = {
    sateenSheet: [
      { n: 'Chris S.', t: 'So smooth and stay put even when your partner moves. Lol' },
      { n: 'Briana R.', t: 'This is the most luxurious yet logical sheet and duvet system we have ever owned. We love it!' },
      { n: 'David A.', t: 'The Align System just works. It keeps everything exactly where it needs to be, and I can’t believe nobody came up with this before. These are super soft, high-quality, and always the perfect temperature.' },
      { n: 'Renee W.', t: 'The moment I opened the Sierra Dreams box & saw the detail of the sheets, I knew these sheets were way different than any others I’ve experienced. They are smooth, soft & keep you cool all night long.' },
      { n: 'J', t: 'LOVE our new Sierra Dreams sheets!! Perfect weight and softness. Best sleep ever!' },
      { n: 'Amelia H.', t: 'I knew I was going to love the snap features, but what I wasn’t expecting to notice was the temperature regulation. My husband sleeps hot, I sleep cold, and we’ve both been sleeping great.' },
      { n: 'Beth B.', t: 'When you want to take your sheets with you on vacation you know they’re great!! Like nothing I have owned before I’ll only purchase these going forward!!' },
      { n: 'Peggy J.', t: 'These are the most comfortable sheets ever-truly!' },
      { n: 'Shelby J.', t: 'I love these sheets! I went back and ordered the duvet insert and duvet cover too. These are probably the most comfortable bedding materials I’ve ever slept on. The snaps that hold them together? These are the best!' },
      { n: 'Kimberli J.', t: 'Customer service is amazing! We originally tried the linen and they just were not for us. We went with the cotton sheet and they have been wonderful.' },
      { n: 'Yesica G.', t: 'I searched far and wide for a brand I could trust, and that’s when I found Sierra Dreams. They don’t cut corners. These sheets are stunning. The quality is unmatched.' },
      { n: 'Sami D.', t: 'I feel like im sleeping on a piece of heaven' },
      { n: 'Annie R.', t: 'The BEST sheets ever! My husband and I will be buying a duvet cover soon because these sheets are a game changer for us!' },
      { n: 'Sunnie K.', t: 'love how they feel and fit!' },
      { n: 'Erin J.', t: 'Great quality and I love the material and snaps!' },
      { n: 'Sydney C.', t: 'I’ve never written a review for sheets, but these sheets are awesome. I love the align system which keeps the sheets in place and makes it so easy to make the bed.' },
      { n: 'Sandra A.', t: 'Love my new Sierra Dreams sheets! They are soft and luxurious not to mention the snap system that holds the top sheet in place so well! I will definitely purchase these for all of my bedrooms!' },
      { n: 'Katherine R.', t: 'This picture is with all snaps in place, but my husband sometimes unsnaps two while sleeping. We really like the temperature regulating ability of the sheets and hope to purchase another set soon.' }
    ],
    linenSheet: [
      { n: 'Norman W.', r: 4, t: 'These came in a very nice package and look and feel marvelous. The snap feature at the bottom works quite well to keep the covers from slipping off the floor of the bed. What an excellent idea.' },
      { n: 'Kemaro D.', t: 'I got the king size European linen sheet set and I am completely in love with it. The linen is soft yet durable and feels so luxurious against the skin, and keeps me comfortable all night long.' },
      { n: 'Kylee L.', t: 'Luxury sheets are a non negotiable for me. These European linen sheets are an absolute game changer. The sheets snap to the fitted sheet so they actually stay put. 10/10 recommend.' },
      { n: 'Marvena P', t: 'I honestly didn’t expect to love these sheets as much as I do. The align system sounded too good to be true, but now I’m spoiled — my flat sheet actually stays where it’s supposed to.' },
      { n: 'Courtney D.', t: 'The sheets are so snuggly! I love knowing that what we’re sleeping in every night is not just not bad for our skin, but actually good for it.' },
      { n: 'Victoria G', t: 'Okay I have to be super honest, these are the best sheets I have ever slept on!! They are so incredibly SOFT & COZY.' },
      { n: 'Stacey R.', t: 'I recently got the European Linen Sheets in Natural and they’re so luxuriously soft and breathable, perfect for keeping cool on warm nights + cozy when it’s cooler.' },
      { n: 'Alana B.', t: 'Sierra Dreams personally recommended the linen set since my husband and I run at totally different temperatures at night — it’s true, you stay at a consistent, comfortable temperature all night long.' },
      { n: 'Micaela B.', t: 'These sheets are AMAZING. Such wonderful quality and feel. The snaps are genius.' },
      { n: 'Jamie T.', t: 'Love them. Feel like they regulate my temperature so much better than my other sheets.' },
      { n: 'Trilby M.', t: 'I was skeptical but I honestly think the reason I’ve slept better these past two weeks is this bedding. Absolutely amazing' },
      { n: 'Brett H.', t: 'Never in my life would I have thought of spending this amount of money on sheets... 100% worth it, soft, cool all night long. Never going back.' },
      { n: 'Rohn S.', t: 'Okay the snaps!! Genius! My bed never gets messed up anymore! And they’re so cool to the touch! No more sleeping hot!' },
      { n: 'Mona S.', t: 'Absolutely love my sheets! I’m sleeping so much better!' },
      { n: 'Jan M.', t: 'The Align Sheet Sets are awesome! Very comfy and I love the snaps, ingenious!' },
      { n: 'Kevin F.', t: 'We feel like we are sleeping in the lap of luxury! Love the breathability and the ample size of the sheets.' },
      { n: 'Diane S.', t: 'I absolutely love my new sheets! I love the crisp, clean way they feel and wish I had them in every color!' }
    ],
    waffleCover: [
      { n: 'Brandi O.', r: 4, t: 'Love the snap buttons to keep the duvet in place and the extra coverage.' },
      { n: 'Sami D.', t: 'My son sleeps through the entire night with these heavenly sheets! The duvet cover is so soft and comfy.' },
      { n: 'David A.', t: 'The Waffle Duvet Cover is beautifully made and surprisingly soft. It connects to the insert in a way that actually keeps it in place — no bunching, no shifting.' },
      { n: 'Courtney D.', t: 'LOVE LOVE LOVE. We bought two of the Sierra Dreams duvet covers and we sleep with both of them — I’m obsessed with that waffle texture.' },
      { n: 'Stacey R.', t: 'I love my waffle duvet cover in natural! The waffle texture is soft, breathable, + cozy without feeling heavy.' },
      { n: 'Audrey W.', t: 'Easy to put together. Much lighter than it looks and very warm' },
      { n: 'Allison A.', t: 'Love! We feel like we are sleeping in a luxury hotel under these duvet covers!' },
      { n: 'Sami', t: 'Best sheet set I have ever used. Hands down its worth it' },
      { n: 'Amanda K.', t: 'Bought these for my boys and 100/100 recommend' },
      { n: 'Megan L.', t: 'Absolutely beautiful! Finally my husband and I aren’t fighting over coverage and warmth. A must have.' }
    ],
    boucleCover: [
      { n: 'Jessica', t: 'This is such a substantial, high quality duvet cover. I’ve never seen anything like it.' },
      { n: 'Alana B.', t: 'If you’re looking for boucle bedding, you will not find one softer than the Sierra Dreams boucle duvet cover — genuinely the softest duvet cover I’ve ever owned.' },
      { n: 'J', t: 'Softest duvet cover we’ve ever had! And the perfect weight and soooo cozy.' },
      { n: 'Katie H.', t: 'I have been looking for a duvet insert and cover that will stay in place! This is amazing.' },
      { n: 'Maggie K.', t: 'The boucle duvet cover feels really good and gives a bit of weight to my duvet, but it’s still breathable so you don’t overheat at night! Feels like a luxury hotel.' },
      { n: 'Thomas Scott H.', t: 'So pretty and soft.' },
      { n: 'McKenna D.', t: 'OBSESSED! The boucle texture is incredibly soft and the snap system is the most genius thing I’ve ever experienced!' },
      { n: 'Barbra C.', t: 'I’ve been happy with the quality. The boucle is thick and soft, not having to adjust your insert is worth it.' },
      { n: 'Jennifer P.', t: 'Textural and sumptuous!' },
      { n: 'Courtney D.', t: 'This is my favorite piece from Sierra Dreams. It’s so soft, so beautiful, and it makes me excited to get into bed every night.' }
    ],
    sateenCover: [
      { n: 'Diana O.', t: 'Beautiful and soft duvet covers. Love them!' },
      { n: 'Maureen G.', t: 'Absolutely best duvet we’ve ever bought! We will tell all our friends!' }
    ],
    insert: [
      { n: 'Jenna P.', t: 'Wow! I have no words. This is the best investment we made in our sleep and health!!! It’s so comfortable, doesn’t slide around.' },
      { n: 'David A.', t: 'We got the standard down-alternative duvet, and it’s super plush. I honestly thought it would be too warm, but it’s perfect in both warm and cool weather.' },
      { n: 'Courtney D.', t: 'This is the highest-quality duvet insert we’ve ever bought, and I can genuinely tell the difference. It keeps me warm without making him sweaty.' },
      { n: 'Alana B.', t: 'We love our duvet insert. It has that perfect weighted feel — weighted and cozy without ever feeling too hot, which was my biggest concern.' },
      { n: 'Alexis B.', t: 'Absolutely genius! We’re obsessed with this align system!' },
      { n: 'Chelsea C.', t: 'It’s truly amazing! So fluffy and large enough for my husband and I not to pull it off each other.' },
      { n: 'Nance B.', t: 'Very soft and comfortable but more importantly eliminates the pain points of insert slipping down, duvet bulging, comforter sticking out.' },
      { n: 'Andrew A.', t: 'This comforter is hypoallergenic and amazing because I am super allergic to down comforters.' },
      { n: 'Lauren M.', t: 'I was looking for a weighted duvet, and the winter weight down duvet insert is just right! Both me and my husband have slept really well since getting it.' },
      { n: 'Madelyn B.', t: 'Perfect balance of fluffiness.' },
      { n: 'Amanda K.', t: 'The BEST BEDDING IVE EVER BOUGHT WOW' },
      { n: 'Carrie K.', t: 'The insert into the duvet cover took a bit of figuring out at first, but now that it’s done, it’s all amazing!' },
      { n: 'Brandi O.', t: 'Love how fluffy the duvet is and how much coverage I have.' },
      { n: 'Stacey R.', t: 'I recently picked up the Airy Natural Kapok Duvet Insert and it’s excellent! The kapok fill feels light yet surprisingly warm, cozy without being bulky.' }
    ]
  };
  // Cover Material/Color show every duvet cover review together rather than
  // segmenting by material - Sateen alone only has 2 real reviews, too thin
  // a pool on its own.
  REVIEWS.allCover = REVIEWS.sateenCover.concat(REVIEWS.boucleCover, REVIEWS.waffleCover);
  // Review/cart page shows real company-level reviews (customer service,
  // shipping, packaging) rather than product-specific ones - a broad
  // "why trust us at checkout" signal, same spirit as the old infographic
  // it replaces. Active-status only, from the store's separate company-
  // reviews export (distinct from the per-product Loox reviews above).
  // Ordered for conversion impact - specific, emotionally compelling
  // service stories first (repeat-purchase intent, CEO involvement,
  // generosity, fast problem-solving), general praise next, short
  // shipping-speed mentions last.
  REVIEWS.all = [
    { n: 'Jillian M.', t: 'The customer service and stellar response time from the team was impeccable… turns out it was better than I even anticipated! I’ll be a repeat customer in the very near future!!' },
    { n: 'Maureen G.', t: 'The CEO reached out via email to tell me what I had ordered was out of stock and they made it right in the most generous way! Awesome customer service!' },
    { n: 'Maggie K.', t: 'Your rep was able to honor a promo I missed, I really appreciate it. I’ve been trying to get a new duvet cover for a couple of months now & was financially tied up. Thank you for helping me make this purchase more affordable!' },
    { n: 'Dana O.', t: 'There was a snag on the comforter I was originally sent and without hesitation they sent a new one. Amazing customer service.' },
    { n: 'Kamie C.', t: 'Great customer service! I will definitely be purchasing again from this company, love the products and the people who were very helpful with my order!' },
    { n: 'Beth B.', t: 'From my first click until receiving a beautifully packaged and timely shipment with clear instructions I couldn’t be more pleased.' },
    { n: 'Erin J.', t: 'Packaging is beautiful and felt special without being over the top. Quick shipping speed. Love what your doing!' },
    { n: 'Lynda S.', t: 'The customer support went above and beyond when I had an issue.' },
    { n: 'Kimberli J.', t: 'Wonderful!! They answered my many questions and directed me in the right way.' },
    { n: 'Marisa O.', t: 'Great customer service. Even the box everything came in was beautiful.' },
    { n: 'Norman W.', t: 'I had one question which was asked and answered in less than 24 hours.' },
    { n: 'Jan M.', t: 'Great products and excellent customer service!' },
    { n: 'Carrie K.', t: 'Excellent personal customer care!' },
    { n: 'Sandra A.', t: 'Awesome customer experience!' },
    { n: 'Sam G.', t: 'Wonderful customer service' },
    { n: 'Mona S.', t: 'Received my order quickly and the packaging felt so luxurious! Will order again.' },
    { n: 'Micaela B.', t: 'Everything shipped quickly and was boxed like royalty.' },
    { n: 'Chris S.', t: 'Quality products with options and clean organic materials love them.' },
    { n: 'Lorri G.', t: 'Got everything pretty seamlessly! Fast delivery.' },
    { n: 'Kathi R.', t: 'No issues. Delivery was prompt.' },
    { n: 'Jamie T.', t: 'Everything went super smooth.' },
    { n: 'Lilia B.', t: 'Fast shipping - outstanding packing' },
    { n: 'Taylor V.', t: 'Good company quick delivery' },
    { n: 'Nancy K.', t: 'Easy quick service' },
    { n: 'Mary D.', t: 'super fast shipping' },
    { n: 'Robb W.', t: 'Well done' },
    { n: 'Jenna R.', r: 4, t: 'Quick shipping' }
  ];

  function renderReviewScroller(containerId, reviews) {
    var row = document.getElementById(containerId);
    if (!row) return;
    var wrap = row.closest('.ab-review-scroll');
    if (!reviews || !reviews.length) {
      if (wrap) wrap.style.display = 'none';
      return;
    }
    if (wrap) wrap.style.display = '';
    row.innerHTML = reviews.map(function (rv) {
      return '<div class="ab-review-proof">' +
        '<div class="ab-review-proof-stars" aria-hidden="true">' + '★'.repeat(rv.r || 5) + '</div>' +
        '<p class="ab-review-proof-quote">“' + rv.t + '”</p>' +
        '<p class="ab-review-proof-name">' + rv.n + '</p>' +
        '</div>';
    }).join('');
  }

  // ---------- accordion panels (fabric/color, cover material/color) ----------
  // A single shared panel per group (e.g. #abFabricPanel) is physically
  // MOVED in the DOM to sit right after whichever option button is
  // currently selected, rather than duplicating the photo+swatches markup
  // once per option - keeps the real gallery/color-grid logic (which
  // already targets these elements by id/data-stage-key) untouched.
  function openAccordionPanel(panel) {
    if (!panel || panel.dataset.open === '1') return;
    panel.style.display = 'block';
    panel.style.overflow = 'hidden';
    panel.style.maxHeight = '0px';
    void panel.offsetHeight; // force reflow so the transition animates from 0
    panel.style.transition = 'max-height .35s ease';
    panel.style.maxHeight = panel.scrollHeight + 'px';
    panel.dataset.open = '1';
    var onEnd = function (e) {
      if (e.propertyName !== 'max-height') return;
      panel.style.maxHeight = 'none';
      panel.removeEventListener('transitionend', onEnd);
    };
    panel.addEventListener('transitionend', onEnd);
    setTimeout(function () {
      panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 60);
  }

  function closeAccordionPanel(panel, done) {
    if (!panel || panel.dataset.open !== '1') { if (done) done(); return; }
    panel.style.maxHeight = panel.scrollHeight + 'px';
    panel.style.overflow = 'hidden';
    void panel.offsetHeight;
    panel.style.transition = 'max-height .3s ease';
    panel.style.maxHeight = '0px';
    panel.dataset.open = '0';
    var onEnd = function (e) {
      if (e.propertyName !== 'max-height') return;
      panel.style.display = 'none';
      panel.removeEventListener('transitionend', onEnd);
      if (done) done();
    };
    panel.addEventListener('transitionend', onEnd);
  }

  // Moves `panel` to sit directly after the option button whose
  // [data-attr="value"] matches `value` (when `show` is true), opening it
  // there; closes and hides it otherwise. `optsSelector` scopes the button
  // lookup to the right step (there are two of these accordions on the
  // page - fabric and cover material).
  function syncAccordionPanel(panel, optsSelector, dataAttr, value, show) {
    if (!panel) return;
    if (!show) { closeAccordionPanel(panel); return; }
    var opts = document.querySelector(optsSelector);
    var targetBtn = opts ? opts.querySelector('[' + dataAttr + '="' + value + '"]') : null;
    if (!targetBtn) { closeAccordionPanel(panel); return; }
    var alreadyThere = targetBtn.nextElementSibling === panel;
    if (alreadyThere) {
      if (panel.dataset.open !== '1') openAccordionPanel(panel);
      return;
    }
    if (panel.dataset.open === '1') {
      closeAccordionPanel(panel, function () {
        targetBtn.insertAdjacentElement('afterend', panel);
        openAccordionPanel(panel);
      });
    } else {
      targetBtn.insertAdjacentElement('afterend', panel);
      openAccordionPanel(panel);
    }
  }

  // ---------- size-based availability ----------
  // Some materials simply aren't offered in every bed size (e.g. European
  // Linen only comes in King/Queen; the Sateen and Boucle duvet covers
  // don't come in Twin/Twin XL) - distinct from a color being sold OUT,
  // this is the product never having that size at all. `sizeMapFn` lets
  // the same helper work for products keyed on the plain bed size (sheets)
  // or the combined size (cover/insert).
  var ALL_BED_SIZES = ['Twin', 'Full', 'Queen', 'King', 'Cal King'];
  function bedSizesOfferedFor(product, sizeMapFn) {
    var offered = optionValues(product, 'Size');
    return ALL_BED_SIZES.filter(function (bedSize) {
      var mapped = sizeMapFn ? sizeMapFn(bedSize) : bedSize;
      return offered.indexOf(mapped) !== -1;
    });
  }
  function humanList(arr) {
    if (arr.length === 0) return '';
    if (arr.length === 1) return arr[0];
    if (arr.length === 2) return arr[0] + ' and ' + arr[1];
    return arr.slice(0, -1).join(', ') + ', and ' + arr[arr.length - 1];
  }

  var SWATCH_CLASS = {
    'Natural (Undyed)': 'ab-sw-natural-undyed',
    'Snow': 'ab-sw-snow',
    'Desert Taupe': 'ab-sw-desert-taupe',
    'Glacier': 'ab-sw-glacier',
    'Granite': 'ab-sw-granite',
    'Slate': 'ab-sw-slate',
    'Dune': 'ab-sw-dune',
    // Percale's real Color option value is plain "Natural" (not "Natural
    // (Undyed)" like Sateen/Linen) - same actual color, just named
    // differently on that product, so it reuses the same swatch class.
    'Natural': 'ab-sw-natural-undyed'
  };

  // Nothing is pre-selected anywhere - every question requires an actual
  // click before Continue unlocks. Bed size is the one thing that, once
  // chosen, is reused for cover/insert sizing rather than asked again -
  // that's a data reuse concern, not a "default selection".
  var state = {
    fabric: null, size: null, color: null,
    duvet: null,
    coverMaterial: null, coverColor: null, coverSize: null,
    insertFill: null, insertLoft: null, insertSize: null, insertSkipped: false,
    pillowType: null, pillows: 0, protector: null,
    // Quantities default to 1 (or 0 for pillows, meaning "not added") and
    // only ever change via the quantity stepper on the Review/cart page -
    // kept here (not just read off the cart) so a later sync never fights
    // a quantity the shopper just set.
    sheetQty: 1, coverQty: 1, insertQty: 1, protectorQty: 1
  };

  var stepIndex = 0;
  var activeSteps = [];

  // Which review line item (if any) has its inline "Edit" panel open right
  // now - only one at a time, matching a simple accordion pattern.
  var expandedReviewItem = null;

  function money(cents) { return '$' + Math.round(cents / 100); }

  function findVariant(product, wantedValues) {
    if (!product) return null;
    return product.variants.find(function (v) {
      return wantedValues.every(function (val) { return val != null && v.options.indexOf(val) !== -1; });
    }) || null;
  }

  function optionValues(product, optionName) {
    if (!product) return [];
    var opt = product.options_with_values ? product.options_with_values.find(function (o) { return o.name === optionName; }) : null;
    if (opt) return opt.values;
    var idx = product.options ? product.options.indexOf(optionName) : -1;
    if (idx === -1) return [];
    var seen = [];
    product.variants.forEach(function (v) {
      var val = v.options[idx];
      if (val && seen.indexOf(val) === -1) seen.push(val);
    });
    return seen;
  }

  // Finds the best variant matching requiredValues, preferring
  // preferredFirst but falling back to any in-stock match so defaults never
  // land on dead stock.
  function findBestVariant(product, requiredValues, preferredFirst) {
    if (!product) return null;
    var candidates = product.variants.filter(function (v) {
      return requiredValues.every(function (val) { return val != null && v.options.indexOf(val) !== -1; });
    });
    if (!candidates.length) return null;
    var preferredMatch = preferredFirst
      ? candidates.find(function (v) { return preferredFirst.every(function (val) { return val == null || v.options.indexOf(val) !== -1; }); })
      : null;
    if (preferredMatch && preferredMatch.available) return preferredMatch;
    var available = candidates.find(function (v) { return v.available; });
    return available || preferredMatch || candidates[0];
  }

  // Estimates the price of a variant on `product` if `requiredNew` (the
  // thing actually being changed, e.g. a new color) were picked while
  // trying to hold `keepValues` (the shopper's other current choices)
  // constant - falling back to any in-stock combo if that exact one isn't
  // available, so the price preview never reflects a dead combo. Used only
  // to show a "+$X" / "-$X" estimate in the Review page's inline editor -
  // the actual pick functions have their own (slightly more thorough)
  // reconciliation for the real selection.
  // `mustKeep` (typically size) is preserved whenever the candidate product
  // offers it at all - falling back to dropping `niceToKeep` (typically
  // color) before ever dropping `mustKeep`, so comparing materials never
  // silently jumps to a different size just because the color didn't carry
  // over (e.g. a material that doesn't come in the currently-picked color).
  function priceForAlternateVariant(product, requiredNew, mustKeep, niceToKeep) {
    if (!product) return null;
    var exact = findVariant(product, requiredNew.concat(mustKeep, niceToKeep));
    if (exact && exact.available) return exact.price;
    var keepingSize = findBestVariant(product, requiredNew.concat(mustKeep), niceToKeep);
    if (keepingSize) return keepingSize.price;
    var anyMatch = findBestVariant(product, requiredNew, mustKeep.concat(niceToKeep));
    return anyMatch ? anyMatch.price : null;
  }

  // Formats a price difference as "+$30" / "-$10" / "Same price".
  function formatDelta(deltaCents) {
    if (deltaCents == null) return '';
    var rounded = Math.round(deltaCents / 100);
    if (rounded === 0) return 'Same price';
    return (rounded > 0 ? '+' : '&minus;') + '$' + Math.abs(rounded);
  }

  // ---------- prices on the Fabric / Cover Material / Insert Fill / Insert
  // Loft option buttons themselves (the steps where price genuinely differs
  // between choices) - before anything's picked, every option shows its own
  // full price; once one is picked, that option shows its price and every
  // other option shows the difference relative to it, same idea as the
  // Review page's inline editor. Color is intentionally left alone (same
  // price either way, so a number there would just be noise).
  function setOptionPrice(idPrefix, key, cents) {
    var el = document.getElementById(idPrefix + '-' + key);
    if (el) el.innerHTML = money(cents);
  }
  function setOptionDelta(idPrefix, key, deltaCents) {
    var el = document.getElementById(idPrefix + '-' + key);
    if (!el) return;
    el.innerHTML = deltaCents == null ? '' : '<span class="ab-op-delta">' + formatDelta(deltaCents) + '</span>';
  }
  // Each of these prices every option independently (regardless of whether
  // anything's picked yet) so the FULL price always shows before a
  // selection is made - once one is picked, that option switches to its own
  // price and the rest switch to the difference relative to it. Nothing is
  // pre-selected, so "no selection yet" is a normal, expected state here,
  // not something to special-case away.
  function updateFabricPrices() {
    var prices = {};
    ['percale', 'sateen', 'linen'].forEach(function (f) {
      prices[f] = priceForAlternateVariant(FABRIC_PRODUCT[f], [], [state.size], [state.color]);
    });
    var selected = (state.fabric === 'sateen' || state.fabric === 'linen' || state.fabric === 'percale') ? state.fabric : null;
    var basis = selected ? prices[selected] : null;
    ['percale', 'sateen', 'linen'].forEach(function (f) {
      if (prices[f] == null) return;
      if (!selected || f === selected) {
        setOptionPrice('abPrice-fabric', f, prices[f]);
      } else {
        setOptionDelta('abPrice-fabric', f, prices[f] - basis);
      }
    });
  }
  function updateCoverMaterialPrices() {
    var prices = {};
    ['percale', 'sateen', 'boucle', 'waffle'].forEach(function (m) {
      prices[m] = priceForAlternateVariant(COVER_PRODUCT[m], [], [state.coverSize], [state.coverColor]);
    });
    var selected = state.coverMaterial;
    var basis = selected ? prices[selected] : null;
    ['percale', 'sateen', 'boucle', 'waffle'].forEach(function (m) {
      if (prices[m] == null) return;
      if (!selected || m === selected) {
        setOptionPrice('abPrice-coverMaterial', m, prices[m]);
      } else {
        setOptionDelta('abPrice-coverMaterial', m, prices[m] - basis);
      }
    });
  }
  function updateInsertFillPrices() {
    var fills = optionValues(DUVET_INSERT, 'Fill Material');
    var prices = {};
    fills.forEach(function (fill) {
      prices[handleize(fill)] = priceForAlternateVariant(DUVET_INSERT, [fill], [state.insertSize], [state.insertLoft]);
    });
    var selectedKey = state.insertFill ? handleize(state.insertFill) : null;
    var basis = selectedKey ? prices[selectedKey] : null;
    fills.forEach(function (fill) {
      var key = handleize(fill);
      if (prices[key] == null) return;
      if (!selectedKey || fill === state.insertFill) {
        setOptionPrice('abPrice-insertFill', key, prices[key]);
      } else {
        setOptionDelta('abPrice-insertFill', key, prices[key] - basis);
      }
    });
  }
  // Loft (Airy/Signature/Plush) works the same way - the anchor follows
  // whichever loft is actually selected, rather than always being pinned to
  // Signature, so the behavior matches every other pricing step.
  function updateInsertLoftPrices() {
    var lofts = optionValues(DUVET_INSERT, 'Loft');
    var prices = {};
    lofts.forEach(function (loft) {
      prices[handleize(loft)] = priceForAlternateVariant(DUVET_INSERT, [loft], [state.insertSize], [state.insertFill]);
    });
    var selectedKey = state.insertLoft ? handleize(state.insertLoft) : null;
    var basis = selectedKey ? prices[selectedKey] : null;
    lofts.forEach(function (loft) {
      var key = handleize(loft);
      if (prices[key] == null) return;
      if (!selectedKey || loft === state.insertLoft) {
        setOptionPrice('abPrice-insertLoft', key, prices[key]);
      } else {
        setOptionDelta('abPrice-insertLoft', key, prices[key] - basis);
      }
    });
  }

  // ---------- step sequence (dynamic) ----------
  function computeSteps() {
    // Bed size is asked first and reused everywhere else (cover/insert
    // sizes itself off it silently - no separate size step for that).
    // Color is no longer its own step - it's picked inline in the
    // Fabric/Cover Material step's expanding panel once a fabric/material
    // with actual color options is chosen.
    // The "add the duvet or just sheets" fork is temporarily removed from
    // the flow - Cover Material now always comes right after Fabric.
    // Skipping the cover (or just the insert) happens via the skip buttons
    // on those steps themselves (skipSheetsOnly()/skipInsertOnly()), which
    // jump straight to Review rather than branching the step sequence here.
    var steps = ['size', 'fabric', 'coverMaterial', 'insertFill'];
    // Pillows and Protector are temporarily removed from the flow - the
    // code/settings are left in place to re-enable later.
    steps.push('review');
    return steps;
  }

  var STEP_META = {
    size: 'Size', fabric: 'Fabric', duvet: 'Duvet',
    coverMaterial: 'Cover Material',
    insertFill: 'Insert Fill',
    pillows: 'Pillows', protector: 'Protector', review: 'Review'
  };

  // ---------- resolved real variants for current state ----------
  function currentSheetProduct() { return FABRIC_PRODUCT[state.fabric]; }
  function currentSheetVariant() { return findVariant(currentSheetProduct(), [state.color, state.size]); }
  function currentCoverProduct() { return COVER_PRODUCT[state.coverMaterial]; }
  function currentCoverVariant() { return findVariant(currentCoverProduct(), [state.coverColor, state.coverSize]); }
  function currentInsertVariant() { return findVariant(DUVET_INSERT, [state.insertSize, state.insertFill, state.insertLoft]); }
  function currentPillowProduct() { return PILLOW_PRODUCT[state.pillowType]; }
  function currentPillowVariant() {
    var size = BED_TO_PILLOW_SIZE[state.size] || 'Standard';
    return findBestVariant(currentPillowProduct(), [size], ['Medium']);
  }
  function currentProtectorVariant() {
    var size = BED_TO_PROTECTOR_SIZE[state.size];
    return findBestVariant(PROTECTOR, [size], ['Natural (Undyed)']);
  }

  // Cover/insert sizes are no longer a separate step the shopper picks -
  // they're derived silently from the bed size chosen up front. Bed size is
  // a HARD requirement, never a droppable one: it must NEVER silently fall
  // back to a different size just because the currently-picked color/fill/
  // loft is out of stock in it (that's the exact bug that shipped a real
  // King order as Queen - the size quietly changed behind the shopper's
  // back). If the size+color combo is unavailable, that has to surface as
  // the COLOR being sold out (see renderCoverColor/applyInsertOptionAvailability),
  // not as a silently substituted size.
  function requiredCombinedSize() { return state.size ? BED_TO_COMBINED_SIZE[state.size] : null; }
  function deriveCoverSize() {
    var product = currentCoverProduct();
    state.coverSize = product ? requiredCombinedSize() : null;
  }
  function deriveInsertSize() {
    state.insertSize = requiredCombinedSize();
  }

  // ---------- dynamic product photography (real gallery, like a PDP) ----------
  // The theme already tags product media with "#<option>_<value>" alt text
  // (e.g. "#color_slate", "#fill-material_natural-kapok-fiber") - the same
  // convention the "gang" color-swap system on the other Align pages reads.
  // We read product.media directly (not a fixed featured_image), so this
  // always reflects whatever images are actually on the product/variant
  // right now - add or remove one in Shopify Admin and it shows up here on
  // the next page load, nothing hardcoded.
  function sizedImageUrl(src, width) {
    if (!src) return src;
    var sep = src.indexOf('?') === -1 ? '?' : '&';
    return src + sep + 'width=' + width;
  }

  function handleize(str) {
    return (str || '')
      .toString()
      .toLowerCase()
      .trim()
      .replace(/['"()]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  // Returns { product, optionSlug, value } describing which media alt tag
  // this step's photos should be filtered by.
  function galleryContextFor(key) {
    // Nothing may be selected yet (Size is asked first, before Fabric, and
    // nothing defaults anymore) - fall back to a canonical PRODUCT *and* a
    // canonical VALUE (never a bare null) purely so the stage has one
    // real, right-sized photo set to show, without either counting as an
    // actual "selection." Passing a null value through to mediaForKey()
    // would skip its tag filter entirely and return the product's ENTIRE
    // media library (every color, mixed with any videos) instead of one
    // color's gallery - exactly the bug that caused several hidden steps
    // to each start auto-playing the same full HD video at once.
    switch (key) {
      case 'fabric': case 'size': case 'color':
        var sheet = currentSheetProduct() || FABRIC_PRODUCT.sateen;
        return { product: sheet, optionSlug: 'color', value: state.color || optionValues(sheet, 'Color')[0] || null };
      case 'duvet':
        // Defaults to the duvet insert (this step is selling the duvet
        // system, not the sheets) - only switches to the sheet photos if
        // the shopper explicitly says they don't want the duvet. Picking
        // "Align Duvet Cover + Insert" keeps showing the insert; the more
        // specific cover-material photo takes over on the next step.
        if (state.duvet === 'none') {
          var noneSheet = currentSheetProduct() || FABRIC_PRODUCT.sateen;
          return { product: noneSheet, optionSlug: 'color', value: state.color || optionValues(noneSheet, 'Color')[0] || null };
        }
        return { product: DUVET_INSERT, optionSlug: 'fill-material', value: state.insertFill || optionValues(DUVET_INSERT, 'Fill Material')[0] || null };
      case 'coverMaterial': case 'coverColor': case 'coverSize':
        var cover = currentCoverProduct() || COVER_PRODUCT.sateen;
        return { product: cover, optionSlug: 'color', value: state.coverColor || optionValues(cover, 'Color')[0] || null };
      case 'insertFill': case 'insertLoft': case 'insertSize':
        // Real tagged photos only exist per Loft value (#loft_airy etc) -
        // Fill Material has none, matching the live PDP's own behavior
        // where picking a Loft swaps the shown photo but picking a Fill
        // does not. Keying this off insertFill (as before) never matched
        // any real tag and silently fell back to the full gallery for
        // every pick, which is why Loft selection had no visible effect.
        return { product: DUVET_INSERT, optionSlug: 'loft', value: state.insertLoft || optionValues(DUVET_INSERT, 'Loft')[0] || null };
      case 'pillows':
        return { product: currentPillowProduct() || PILLOW_PRODUCT.regular, optionSlug: null, value: null };
      case 'protector':
        return { product: PROTECTOR, optionSlug: 'color', value: 'Natural (Undyed)' };
      default:
        return null;
    }
  }

  // Picks the largest real mp4 rendition off a video media object (skips
  // the .m3u8 HLS stream - a plain <video> tag can't play that directly).
  function bestVideoSource(media) {
    var mp4s = (media.sources || []).filter(function (s) { return s.format === 'mp4'; });
    return mp4s.reduce(function (best, s) { return (!best || s.width > best.width) ? s : best; }, null);
  }

  // Normalizes a raw product.media entry into what the gallery renderer
  // needs, whether it's a photo or a native product video - same media
  // shown on the product page shows up here too.
  function toMediaItem(m) {
    if (m.media_type === 'video') {
      var source = bestVideoSource(m);
      return { type: 'video', src: source ? source.url : null, poster: m.preview_image ? sizedImageUrl(m.preview_image.src, 1200) : null };
    }
    return { type: 'image', src: sizedImageUrl(m.src, 1200) };
  }

  // A small thumbnail for a Review line item - same tagged-media lookup
  // the galleries already use (e.g. "#color_slate"), just narrowed to a
  // single small image instead of a full gallery. Falls back to the
  // product's first image if there's no tagged match for the exact
  // color/fill picked, so a line item is never left without a thumbnail.
  function firstImageFor(product, optionSlug, value) {
    if (!product) return null;
    var images = (product.media || []).filter(function (m) { return m.media_type === 'image'; });
    if (optionSlug && value) {
      var tag = '#' + optionSlug + '_' + handleize(value);
      var tagged = images.find(function (m) { return m.alt === tag; });
      if (tagged) return sizedImageUrl(tagged.src, 160);
    }
    return images.length ? sizedImageUrl(images[0].src, 160) : null;
  }

  function mediaForKey(key) {
    var ctx = galleryContextFor(key);
    if (!ctx || !ctx.product) return [];

    var allMedia = (ctx.product.media || []).filter(function (m) { return m.media_type === 'image' || m.media_type === 'video'; });
    var featuredSrc = null;
    if (ctx.optionSlug && ctx.value) {
      var withImage = (ctx.product.variants || []).filter(function (v) {
        return v.options.indexOf(ctx.value) !== -1 && v.featured_image;
      });
      var chosen = withImage.find(function (v) { return v.available; }) || withImage[0];
      if (chosen) featuredSrc = chosen.featured_image.src;
    }

    // Every photo tagged for this value (#color_slate etc) - an image can
    // carry more than one tag as a comma-separated alt (e.g. a hero shot
    // reused across several colors), so this matches on tag membership,
    // not exact-equality. Shown as a full gallery (the shopper can swipe
    // through all of it), with the variant's own featured_image leading
    // the set when it's part of the tagged group, so the stage still
    // opens on the same clean product shot the PDP leads with.
    if (ctx.optionSlug && ctx.value) {
      var tag = '#' + ctx.optionSlug + '_' + handleize(ctx.value);
      var tagged = allMedia.filter(function (m) { return (m.alt || '').split(',').indexOf(tag) !== -1; });
      if (tagged.length) {
        tagged.sort(function (a, b) {
          if (a.src === featuredSrc) return -1;
          if (b.src === featuredSrc) return 1;
          return 0;
        });
        return tagged.map(toMediaItem);
      }
    }

    // No tagged gallery for this value - the variant-to-image connection
    // that drives the real PDP (variant.featured_image) is the next best
    // single source of truth, so updating a photo on the PDP updates it
    // here automatically with nothing else to maintain.
    if (featuredSrc) return [toMediaItem({ media_type: 'image', src: featuredSrc })];

    // Neither exists for this value - fall back to the product's full
    // gallery so the stage is never blank.
    return allMedia.map(toMediaItem);
  }

  var galleryState = {}; // { [stepKey]: { images, index, signature } }

  function renderGallery(stage, key) {
    var gs = galleryState[key];
    var item = gs.images[gs.index];
    stage.classList.add('ab-stage--square');
    stage.innerHTML = '';
    var mediaEl;
    if (item.type === 'video') {
      mediaEl = document.createElement('video');
      mediaEl.src = item.src;
      if (item.poster) mediaEl.poster = item.poster;
      mediaEl.autoplay = true;
      mediaEl.muted = true;
      mediaEl.loop = true;
      mediaEl.controls = true;
      mediaEl.playsInline = true;
      mediaEl.setAttribute('preload', 'metadata');
    } else {
      mediaEl = document.createElement('img');
      mediaEl.alt = '';
      mediaEl.src = item.src;
    }
    mediaEl.className = 'ab-stage-dynamic';
    stage.appendChild(mediaEl);

    if (gs.images.length > 1) {
      var prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'ab-gallery-btn ab-gallery-btn--prev';
      prevBtn.setAttribute('aria-label', 'Previous photo');
      prevBtn.innerHTML = '&#8249;';
      prevBtn.onclick = function (e) {
        e.stopPropagation();
        gs.index = (gs.index - 1 + gs.images.length) % gs.images.length;
        renderGallery(stage, key);
      };
      var nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'ab-gallery-btn ab-gallery-btn--next';
      nextBtn.setAttribute('aria-label', 'Next photo');
      nextBtn.innerHTML = '&#8250;';
      nextBtn.onclick = function (e) {
        e.stopPropagation();
        gs.index = (gs.index + 1) % gs.images.length;
        renderGallery(stage, key);
      };
      var counter = document.createElement('span');
      counter.className = 'ab-gallery-counter';
      counter.textContent = (gs.index + 1) + ' / ' + gs.images.length;
      stage.appendChild(prevBtn);
      stage.appendChild(nextBtn);
      stage.appendChild(counter);
    }
  }

  // Only ever renders real media (an <img>, or worse, an autoplaying
  // <video>) into the CURRENTLY VISIBLE step's stage - every other step's
  // markup sits hidden in the DOM the whole time, and has nothing to gain
  // from a real, fetched/decoded media element sitting there unseen.
  // Getting ahead of the next few steps is still handled separately (and
  // much more cheaply) by preloadUpcomingSteps()'s plain `new Image()`
  // cache-warming, which never touches the DOM or plays video.
  function updateStageImages() {
    document.querySelectorAll('.ab-step.on .ab-stage[data-stage-key]').forEach(function (stage) {
      var key = stage.getAttribute('data-stage-key');
      var media = mediaForKey(key);
      if (!media.length) return; // leave whatever Liquid rendered (manual image or placeholder)
      var signature = media.map(function (m) { return m.type + ':' + m.src; }).join('|');
      if (!galleryState[key] || galleryState[key].signature !== signature) {
        galleryState[key] = { images: media, index: 0, signature: signature };
      }
      renderGallery(stage, key);
    });
  }

  // ---------- preloading ----------
  // The visible lag was every gallery image being a genuinely fresh network
  // request the instant it was needed - nothing had warmed the browser
  // cache beforehand. These fire the same image requests early (while the
  // shopper is still reading/deciding on the previous step) so by the time
  // a photo is actually shown, it's already cached and paints instantly.
  var preloadedUrls = {};
  function preloadImage(url) {
    if (!url || preloadedUrls[url]) return;
    preloadedUrls[url] = true;
    var img = new Image();
    img.src = url;
  }
  function preloadFirstImagePerValue(product, optionSlug, values) {
    if (!product) return;
    (values || []).forEach(function (value) {
      var tag = '#' + optionSlug + '_' + handleize(value);
      var match = (product.media || []).find(function (m) { return (m.media_type === 'image' || m.media_type === 'video') && m.alt === tag; });
      if (!match) return;
      // Videos aren't preloaded as files (too heavy for a "just in case"
      // warm-up) - just their poster frame, so the stage never looks blank.
      if (match.media_type === 'video') {
        if (match.preview_image) preloadImage(sizedImageUrl(match.preview_image.src, 1200));
      } else {
        preloadImage(sizedImageUrl(match.src, 1200));
      }
    });
  }
  // Preloads every photo in the gallery for the given key (not just the
  // first), so clicking through a step's own gallery arrows feels instant.
  // Video entries only preload their poster image, same reasoning as above.
  function preloadFullGalleryFor(key) {
    mediaForKey(key).forEach(function (item) {
      if (item.type === 'image') preloadImage(item.src);
      else if (item.type === 'video' && item.poster) preloadImage(item.poster);
    });
  }

  // ---------- open/close ----------
  function openBuilder() {
    var el = document.querySelector('.ab-builder');
    if (!el) return;
    el.classList.add('on');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('ab-builder-open');
    activeSteps = computeSteps();
    stepIndex = 0;
    renderFabricSelection();
    renderSizes();
    renderColors();
    showStep();
  }
  function closeBuilder() {
    var el = document.querySelector('.ab-builder');
    if (!el) return;
    el.classList.remove('on');
    document.body.style.overflow = '';
    document.body.classList.remove('ab-builder-open');
  }

  // ---------- step nav ----------
  function currentStepKey() { return activeSteps[stepIndex]; }

  function showStep() {
    var key = currentStepKey();
    document.querySelectorAll('.ab-step').forEach(function (s) { s.classList.remove('on'); });
    var current = document.querySelector('.ab-step[data-step-key="' + key + '"]');
    if (current) current.classList.add('on');
    document.querySelector('.ab-progress .ab-bar').style.width = ((stepIndex + 1) / activeSteps.length * 100) + '%';
    document.getElementById('abStepLabel').textContent = 'Step ' + (stepIndex + 1) + ' of ' + activeSteps.length + ' · ' + STEP_META[key];
    document.getElementById('abBackBtn').classList.toggle('ab-back-hidden', stepIndex === 0);
    var cont = document.getElementById('abContBtn');
    if (key === 'review') cont.textContent = 'Checkout';
    else cont.textContent = 'Continue';

    if (key === 'fabric') renderFabricSelection();
    if (key === 'coverMaterial') renderCoverMaterial();
    if (key === 'insertFill') renderInsertFill();
    if (key === 'review') {
      buildReview('abReviewList');
      renderReviewScroller('abReviewPageReviewRow', REVIEWS.all);
    }

    updateTotal();
    preloadUpcomingSteps();
    var body = document.querySelector('.ab-body');
    if (body) body.scrollTop = 0;
  }

  // Warms the next few steps' photos in the background the instant the
  // shopper lands on a step, rather than waiting for them to actually
  // reach it - this is what keeps images feeling instant throughout the
  // whole flow, not just at the very start.
  function preloadUpcomingSteps() {
    var lookahead = 3;
    for (var i = stepIndex; i < Math.min(stepIndex + 1 + lookahead, activeSteps.length); i++) {
      preloadFullGalleryFor(activeSteps[i]);
    }
  }

  function nextStep() {
    if (currentStepKey() === 'review') { placeOrder(); return; }
    if (!stepIsComplete(currentStepKey())) return;
    activeSteps = computeSteps();
    var key = currentStepKey();
    var newIndex = activeSteps.indexOf(key);
    stepIndex = (newIndex === -1 ? stepIndex : newIndex) + 1;
    if (stepIndex < activeSteps.length) showStep();
  }
  function prevStep() {
    if (stepIndex > 0) {
      activeSteps = computeSteps();
      stepIndex--;
      showStep();
    }
  }
  function goToStep(key) {
    activeSteps = computeSteps();
    var idx = activeSteps.indexOf(key);
    if (idx !== -1) { stepIndex = idx; showStep(); }
  }

  // Disables an option button outright (distinct from "sold out" - the
  // product just doesn't come in the chosen bed size at all) and labels it
  // with which sizes it IS offered in.
  function applySizeAvailabilityNote(btn, product, sizeMapFn) {
    var note = btn.querySelector('.ab-opt-note');
    var offered = state.size ? bedSizesOfferedFor(product, sizeMapFn) : null;
    var unavailable = !!offered && offered.indexOf(state.size) === -1;
    btn.disabled = unavailable;
    if (unavailable) {
      if (!note) {
        note = document.createElement('span');
        note.className = 'ab-opt-note';
        var oc = btn.querySelector('.ab-oc');
        if (oc) oc.appendChild(note);
      }
      note.textContent = 'Only offered in ' + humanList(offered);
    } else if (note) {
      note.remove();
    }
  }

  // ---------- fabric ----------
  function renderFabricSelection() {
    // If the currently-picked fabric turns out not to be offered in the
    // bed size (e.g. the shopper went back and switched to a size it
    // doesn't come in), clear it rather than leaving a stale, invalid
    // selection in place - they have to consciously re-pick.
    if (state.fabric && state.fabric !== 'none' && state.size) {
      if (bedSizesOfferedFor(FABRIC_PRODUCT[state.fabric], null).indexOf(state.size) === -1) {
        state.fabric = null;
        state.color = null;
      }
    }
    document.querySelectorAll('[data-ab-fabric]').forEach(function (btn) {
      var f = btn.getAttribute('data-ab-fabric');
      btn.classList.toggle('sel', f === state.fabric);
      if (FABRIC_PRODUCT[f]) applySizeAvailabilityNote(btn, FABRIC_PRODUCT[f], null);
    });
    renderReviewScroller('abFabricReviewRow', REVIEWS[state.fabric === 'linen' ? 'linenSheet' : 'sateenSheet']);

    var showPanel = state.fabric === 'sateen' || state.fabric === 'linen' || state.fabric === 'percale';
    if (showPanel) renderColors();
    syncAccordionPanel(document.getElementById('abFabricPanel'), '#abFabricOpts', 'data-ab-fabric', state.fabric, showPanel);
  }

  // Keeps state.size/state.color valid for the CURRENT fabric, no matter
  // how the shopper got here - clicking a fabric option, or just clicking
  // Continue past it while sateen (the default) stays pre-selected. Called
  // both from pickFabric() and from renderColors() (so simply reaching the
  // Color step is enough to self-correct a stale/sold-out combo).
  function reconcileSheetSelection() {
    var sheet = currentSheetProduct();
    if (!sheet) return;
    var sizes = optionValues(sheet, 'Size');
    var colors = optionValues(sheet, 'Color');
    // Only ever CORRECTS an already-made choice that's gone stale/sold-out
    // for the newly-picked fabric - never invents an initial size/color, so
    // nothing looks pre-selected before the shopper actually clicks.
    if (state.size !== null && (sizes.indexOf(state.size) === -1 || !anyVariantAvailable(sheet, [state.size]))) {
      var fallbackSize = sizes.find(function (s) { return anyVariantAvailable(sheet, [s]); });
      state.size = fallbackSize || sizes[0] || null;
    }
    if (state.color !== null && (colors.indexOf(state.color) === -1 || !anyVariantAvailable(sheet, [state.color, state.size]))) {
      var fallbackColor = colors.find(function (c) { return anyVariantAvailable(sheet, [c, state.size]); });
      state.color = fallbackColor || colors[0] || null;
    }
  }

  function pickFabric(el, f) {
    if (f !== 'none' && state.size && bedSizesOfferedFor(FABRIC_PRODUCT[f], null).indexOf(state.size) === -1) return;
    state.fabric = f;
    renderFabricSelection();

    if (f === 'none') {
      // No sheet purchase, so no color to pick - but keep (or set) a bed
      // size, since cover/insert/protector still size themselves off it.
      state.color = null;
      if (!state.size) {
        var genericSizes = optionValues(FABRIC_PRODUCT.sateen, 'Size');
        state.size = genericSizes[0] || null;
      }
      renderSizes();
      updateTotal();
      return;
    }

    reconcileSheetSelection();
    var sheet = currentSheetProduct();
    renderSizes();
    updateTotal();
    preloadFirstImagePerValue(sheet, 'color', optionValues(sheet, 'Color'));
    preloadFullGalleryFor('color');
  }

  function pickOpt(el, key, val) {
    state[key] = val;
    var group = el.closest('.ab-opts');
    if (group) group.querySelectorAll('.ab-opt').forEach(function (o) { o.classList.remove('sel'); });
    el.classList.add('sel');
    updateTotal();
  }

  function pickDuvet(el, val) {
    state.duvet = val;
    if (val === 'none') {
      state.coverMaterial = null; state.coverColor = null; state.coverSize = null;
      state.insertFill = null; state.insertLoft = null; state.insertSize = null;
    } else {
      // val === 'full' - the only other option now that "cover only" has
      // been removed (the cover and insert are always bundled together as
      // the Align™ Duvet Cover + Insert). No material is pre-picked - the
      // shopper chooses on the next step - so just warm up all three so
      // whichever they land on is ready.
      ['sateen', 'boucle', 'waffle', 'percale'].forEach(function (m) {
        preloadFirstImagePerValue(COVER_PRODUCT[m], 'color', optionValues(COVER_PRODUCT[m], 'Color').slice(0, 1));
      });
      preloadFirstImagePerValue(DUVET_INSERT, 'fill-material', optionValues(DUVET_INSERT, 'Fill Material'));
    }
    pickOpt(el, 'duvet', val);
  }

  // True if ANY variant matching partialValues is in stock - used so the
  // Size step (asked before Color) doesn't mark a whole size "sold out"
  // just because it happens to be out of stock in the not-yet-chosen
  // default color.
  function anyVariantAvailable(product, partialValues) {
    if (!product) return true;
    return product.variants.some(function (v) {
      return partialValues.every(function (val) { return val == null || v.options.indexOf(val) !== -1; }) && v.available;
    });
  }

  function renderSizes() {
    var g = document.getElementById('abSizeGrid');
    if (!g) return;
    g.innerHTML = '';
    // Size is asked before Fabric, and nothing defaults - so this step must
    // never be constrained by whichever fabric happens to be picked,
    // including a STALE pick from before the shopper came back here (e.g.
    // Linen was picked, then they went back to Size - Twin/Full shouldn't
    // gray out just because Linen doesn't come in them). Always list every
    // canonical bed size, available if ANY fabric offers it in stock - the
    // Fabric step (next) is what grays out a specific material for
    // whichever size actually gets chosen.
    ALL_BED_SIZES.forEach(function (s) {
      var available = anyVariantAvailable(FABRIC_PRODUCT.sateen, [s]) || anyVariantAvailable(FABRIC_PRODUCT.linen, [s]) || anyVariantAvailable(FABRIC_PRODUCT.percale, [s]);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ab-size' + (s === state.size ? ' sel' : '');
      if (!available) b.disabled = true;
      b.innerHTML = '<div class="ab-sn">' + s + '</div>' + (available ? '' : '<div class="ab-sp">Sold out</div>');
      b.onclick = function () {
        // Size is the very first step now - fabric/color haven't been
        // chosen yet, so there's nothing else to reconcile here. (If the
        // shopper goes back and changes size after already picking a
        // fabric/color, pickFabric()/renderColors() re-validate those when
        // next visited.)
        state.size = s;
        renderSizes();
        updateTotal();
      };
      g.appendChild(b);
    });
  }

  function renderColors() {
    var g = document.getElementById('abColorGrid');
    if (!g) return;
    reconcileSheetSelection();
    g.innerHTML = '';
    var sheet = currentSheetProduct();
    optionValues(sheet, 'Color').forEach(function (c) {
      // Size is chosen first in this flow, so once it's set, a color is
      // only "sold out" if it doesn't have THIS size - not sold out in
      // general.
      var available = state.size ? anyVariantAvailable(sheet, [c, state.size]) : true;
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'ab-color' + (c === state.color ? ' sel' : '');
      if (!available) d.disabled = true;
      var swatchClass = SWATCH_CLASS[c] || '';
      d.innerHTML = '<span class="ab-sw ' + swatchClass + '"></span><span class="ab-cn">' + c + (available ? '' : ' · Sold out') + '</span>';
      d.onclick = function () { state.color = c; renderColors(); updateTotal(); };
      g.appendChild(d);
    });
  }

  // ---------- cover sub-steps ----------
  function renderCoverMaterial() {
    // Same reconciliation as renderFabricSelection() - if the picked cover
    // material isn't offered in the (possibly since-changed) bed size,
    // clear it rather than leave a stale, invalid selection in place.
    if (state.coverMaterial && state.size) {
      if (bedSizesOfferedFor(COVER_PRODUCT[state.coverMaterial], function (s) { return BED_TO_COMBINED_SIZE[s]; }).indexOf(state.size) === -1) {
        state.coverMaterial = null;
        state.coverColor = null;
      }
    }
    document.querySelectorAll('[data-ab-cover-material]').forEach(function (btn) {
      var m = btn.getAttribute('data-ab-cover-material');
      btn.classList.toggle('sel', m === state.coverMaterial);
      applySizeAvailabilityNote(btn, COVER_PRODUCT[m], function (s) { return BED_TO_COMBINED_SIZE[s]; });
    });
    renderReviewScroller('abCoverMaterialReviewRow', REVIEWS.allCover);

    var showPanel = state.coverMaterial !== null;
    if (showPanel) renderCoverColor();
    syncAccordionPanel(document.getElementById('abCoverMaterialPanel'), '#abCoverMaterialOpts', 'data-ab-cover-material', state.coverMaterial, showPanel);
  }
  function pickCoverMaterial(el, material) {
    if (state.size && bedSizesOfferedFor(COVER_PRODUCT[material], function (s) { return BED_TO_COMBINED_SIZE[s]; }).indexOf(state.size) === -1) return;
    state.coverMaterial = material;
    renderCoverMaterial();
    var product = currentCoverProduct();
    var colors = optionValues(product, 'Color');
    // Only re-validates a color the shopper already picked (if it doesn't
    // exist for the newly-picked material at all) - never invents a first
    // choice. Availability against the shopper's actual bed size is
    // renderCoverColor()'s job (called above via renderCoverMaterial), and
    // state.coverSize itself is always just the bed-size mapping - see
    // deriveCoverSize().
    if (state.coverColor !== null && colors.indexOf(state.coverColor) === -1) state.coverColor = colors[0] || null;
    updateTotal();
    preloadFirstImagePerValue(product, 'color', colors);
    preloadFullGalleryFor('coverColor');
  }
  function renderCoverColor() {
    var g = document.getElementById('abCoverColorGrid');
    if (!g) return;
    g.innerHTML = '';
    var product = currentCoverProduct();
    var colors = optionValues(product, 'Color');
    var requiredSize = requiredCombinedSize();
    if (state.coverColor !== null && colors.indexOf(state.coverColor) === -1) state.coverColor = colors[0] || null;
    // Never leave a color selected that isn't actually in stock for the
    // shopper's real bed size - this is the exact gap that let a King
    // order silently ship as Queen (the color looked pickable here, then
    // deriveCoverSize() had to quietly downgrade the size to match it).
    if (state.coverColor !== null && requiredSize && !anyVariantAvailable(product, [state.coverColor, requiredSize])) {
      state.coverColor = null;
    }
    colors.forEach(function (c) {
      var available = requiredSize ? anyVariantAvailable(product, [c, requiredSize]) : anyVariantAvailable(product, [c]);
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'ab-color' + (c === state.coverColor ? ' sel' : '');
      if (!available) d.disabled = true;
      var swatchClass = SWATCH_CLASS[c] || '';
      d.innerHTML = '<span class="ab-sw ' + swatchClass + '"></span><span class="ab-cn">' + c + (available ? '' : ' · Sold out') + '</span>';
      d.onclick = function () {
        if (!anyVariantAvailable(product, requiredSize ? [c, requiredSize] : [c])) return;
        state.coverColor = c; renderCoverColor(); updateTotal();
      };
      g.appendChild(d);
    });
  }
  // ---------- insert sub-steps ----------
  // Fill Material and Loft are two options on the same insert product, and
  // not every combination exists (e.g. Premium Down Alternative doesn't
  // come in Airy loft) - each side disables whichever of its own options
  // the OTHER side's current pick rules out, and self-corrects a stale
  // pick that's gone invalid, same pattern as size/fabric availability.
  // Bed size is ALWAYS part of this check too (never optional) - a fill or
  // loft that's out of stock in the shopper's actual bed size has to show
  // as disabled here, not get silently sized down later by
  // deriveInsertSize().
  function applyInsertOptionAvailability(btn, value, otherOptionValue) {
    var note = btn.querySelector('.ab-opt-note');
    var requiredSize = requiredCombinedSize();
    var unavailableForSize = requiredSize != null && !anyVariantAvailable(DUVET_INSERT, [value, requiredSize]);
    var unavailableForOther = !unavailableForSize && otherOptionValue != null && !anyVariantAvailable(DUVET_INSERT, [value, otherOptionValue, requiredSize]);
    var unavailable = unavailableForSize || unavailableForOther;
    btn.disabled = unavailable;
    if (unavailable) {
      if (!note) {
        note = document.createElement('span');
        note.className = 'ab-opt-note';
        var oc = btn.querySelector('.ab-oc');
        if (oc) oc.appendChild(note);
      }
      note.textContent = unavailableForSize ? 'Not available in your size' : ('Not available with ' + otherOptionValue);
    } else if (note) {
      note.remove();
    }
  }
  function renderInsertFill() {
    var fills = optionValues(DUVET_INSERT, 'Fill Material');
    var requiredSize = requiredCombinedSize();
    if (state.insertFill !== null && fills.indexOf(state.insertFill) === -1) state.insertFill = fills[0] || null;
    // Never leave a fill selected that isn't actually in stock for the
    // shopper's real bed size - same root cause as the cover-color bug:
    // a combo that only exists in a different size must never silently
    // resize the order, it has to clear the pick instead.
    if (state.insertFill !== null && requiredSize && !anyVariantAvailable(DUVET_INSERT, [state.insertFill, requiredSize])) {
      state.insertFill = null;
    }
    if (state.insertFill !== null && state.insertLoft !== null && !anyVariantAvailable(DUVET_INSERT, [state.insertFill, state.insertLoft, requiredSize])) {
      state.insertFill = null;
    }
    document.querySelectorAll('[data-ab-insert-fill]').forEach(function (btn) {
      var fill = btn.getAttribute('data-ab-insert-fill');
      btn.classList.toggle('sel', fill === state.insertFill);
      applyInsertOptionAvailability(btn, fill, state.insertLoft);
    });
    renderReviewScroller('abInsertFillReviewRow', REVIEWS.insert);

    var showPanel = state.insertFill !== null;
    if (showPanel) renderInsertLoft();
    syncAccordionPanel(document.getElementById('abInsertFillPanel'), '#abInsertFillOpts', 'data-ab-insert-fill', state.insertFill, showPanel);
  }
  // Fill and Loft now live on one merged step (Loft expands in an
  // accordion panel below whichever fill is picked), so picking either one
  // has to immediately refresh the OTHER side's disabled/note state too -
  // otherwise a combo that just became invalid would keep showing as
  // pickable until the shopper left and came back.
  function pickInsertFill(el, fill) {
    var requiredSize = requiredCombinedSize();
    if (requiredSize && !anyVariantAvailable(DUVET_INSERT, [fill, requiredSize])) return;
    if (state.insertLoft !== null && !anyVariantAvailable(DUVET_INSERT, [fill, state.insertLoft, requiredSize])) return;
    state.insertFill = fill;
    state.insertSkipped = false;
    renderInsertFill();
    updateTotal();
    preloadFullGalleryFor('insertFill');
  }
  function renderInsertLoft() {
    var lofts = optionValues(DUVET_INSERT, 'Loft');
    var requiredSize = requiredCombinedSize();
    if (state.insertLoft !== null && lofts.indexOf(state.insertLoft) === -1) state.insertLoft = lofts[0] || null;
    if (state.insertLoft !== null && requiredSize && !anyVariantAvailable(DUVET_INSERT, [state.insertLoft, requiredSize])) {
      state.insertLoft = null;
    }
    if (state.insertLoft !== null && state.insertFill !== null && !anyVariantAvailable(DUVET_INSERT, [state.insertFill, state.insertLoft, requiredSize])) {
      state.insertLoft = null;
    }
    document.querySelectorAll('[data-ab-insert-loft]').forEach(function (btn) {
      var loft = btn.getAttribute('data-ab-insert-loft');
      btn.classList.toggle('sel', loft === state.insertLoft);
      applyInsertOptionAvailability(btn, loft, state.insertFill);
    });
  }
  function pickInsertLoft(el, loft) {
    var requiredSize = requiredCombinedSize();
    if (requiredSize && !anyVariantAvailable(DUVET_INSERT, [loft, requiredSize])) return;
    if (state.insertFill !== null && !anyVariantAvailable(DUVET_INSERT, [state.insertFill, loft, requiredSize])) return;
    state.insertLoft = loft;
    renderInsertLoft();
    renderInsertFill();
    updateTotal();
  }
  function pickPillowType(el, type) {
    state.pillowType = type;
    document.querySelectorAll('[data-ab-pillow]').forEach(function (btn) {
      btn.classList.toggle('sel', btn.getAttribute('data-ab-pillow') === type);
    });
    updateTotal();
    preloadFullGalleryFor('pillows');
  }
  function changePillows(d) {
    state.pillows = Math.max(0, Math.min(4, state.pillows + d));
    document.getElementById('abPillowN').textContent = state.pillows;
    updateTotal();
  }

  // ---------- pricing ----------
  // Each line item counts toward the total as soon as the shopper has made
  // the ONE choice that item actually needs (a fabric, a cover material, a
  // fill or loft) - it doesn't wait for every remaining sub-choice (color,
  // the other of fill/loft) to land on one exact SKU first. Falls back to
  // the best-guess in-stock variant for whatever isn't picked yet, same
  // estimate the option buttons themselves already show.
  function total() {
    var t = 0;
    if (state.fabric && state.fabric !== 'none') {
      // Size is a hard requirement here, never a droppable preference - a
      // fallback that ignores it (e.g. because the first color happens to
      // be sold out in this size) would silently price a DIFFERENT size,
      // which is exactly the "price doesn't match the size" bug this
      // guards against. Color, not yet picked at this point in the flow,
      // stays a soft preference.
      var sheetVariant = currentSheetVariant() || findBestVariant(currentSheetProduct(), [state.size], [state.color]);
      if (sheetVariant) t += sheetVariant.price * state.sheetQty;
    }
    // Cover is included unless the shopper explicitly skipped it via the
    // "Just the sheets for now" button (state.duvet === 'skip'). Insert is
    // included unless it was explicitly skipped via its own "No duvet
    // insert for now" button (state.insertSkipped) - the two are now
    // independent, since the old single "duvet" fork no longer bundles them.
    if (state.duvet !== 'skip') {
      if (state.coverMaterial) {
        var cover = currentCoverVariant() || findBestVariant(currentCoverProduct(), [state.coverSize], [state.coverColor]);
        if (cover) t += cover.price * state.coverQty;
      }
      if (!state.insertSkipped && (state.insertFill || state.insertLoft)) {
        var insert = currentInsertVariant() || findBestVariant(DUVET_INSERT, [state.insertSize], [state.insertFill, state.insertLoft]);
        if (insert) t += insert.price * state.insertQty;
      }
    }
    if (state.pillows > 0) {
      var pillowVariant = currentPillowVariant();
      if (pillowVariant) t += pillowVariant.price * state.pillows;
    }
    if (state.protector === 'yes') {
      var protectorVariant = currentProtectorVariant();
      if (protectorVariant) t += protectorVariant.price * state.protectorQty;
    }
    return t;
  }
  // A step counts as "complete" once the shopper has actually clicked
  // something for it - nothing is pre-picked, so Continue stays disabled
  // until they do. Bed size is the one exception that then carries through
  // every later step silently (cover/insert size off it, no re-asking).
  function stepIsComplete(key) {
    switch (key) {
      case 'size': return state.size !== null;
      case 'fabric': return state.fabric !== null && (state.fabric === 'none' || state.color !== null);
      case 'coverMaterial': return state.coverMaterial !== null && state.coverColor !== null;
      case 'insertFill': return state.insertSkipped || (state.insertFill !== null && state.insertLoft !== null);
      default: return true; // pillows/protector (disabled) and review (has its own check)
    }
  }

  function updateTotal() {
    // Bed size is chosen once up front now - keep cover/insert sizing in
    // sync with it (and with whatever material/color is currently picked)
    // every time anything changes, rather than asking again as its own step.
    // Cover Material and Insert Fill are always in the flow now (no more
    // fork to gate this on) - always keep their sizes in sync with the bed
    // size, same as before.
    deriveCoverSize();
    deriveInsertSize();

    // Review step manages its own footer total AND Continue/Checkout
    // disabled state (based on the REAL cart, via
    // buildReview()/renderReviewFromCart()) - don't fight it here. Every
    // other step still shows this build's own running total, since
    // nothing's actually in the cart yet to reflect.
    var key = currentStepKey();
    if (key !== 'review') {
      var el = document.getElementById('abTotalVal');
      if (el) el.innerHTML = money(total()) + ' <small>+ tax</small>';
      var cont = document.getElementById('abContBtn');
      if (cont) cont.toggleAttribute('disabled', !stepIsComplete(key));
    }
    updateFabricPrices();
    updateCoverMaterialPrices();
    updateInsertFillPrices();
    updateInsertLoftPrices();
    updateStageImages();
  }

  // ---------- review ----------
  // ---------- inline "Edit" panels on the Review step ----------
  // Lets a shopper change material/color (sheet, cover) or fill/loft
  // (insert) right from the Review line item, with a live price
  // difference per alternative - rather than leaving the review page.
  // Size is intentionally not editable here: it's still tied to the one
  // bed-size question asked up front.
  function toggleReviewEdit(key) {
    expandedReviewItem = (expandedReviewItem === key) ? null : key;
    buildReview('abReviewList');
  }

  function reviewPickFabric(f) {
    if (f === state.fabric) return;
    pickFabric(null, f);
    buildReview('abReviewList');
  }
  function reviewPickColor(c) {
    if (c === state.color) return;
    if (state.size && !anyVariantAvailable(currentSheetProduct(), [c, state.size])) return;
    state.color = c;
    updateTotal();
    buildReview('abReviewList');
  }
  function reviewPickCoverMaterial(material) {
    if (material === state.coverMaterial) return;
    pickCoverMaterial(null, material);
    buildReview('abReviewList');
  }
  function reviewPickCoverColor(c) {
    if (c === state.coverColor) return;
    var requiredSize = requiredCombinedSize();
    if (requiredSize && !anyVariantAvailable(currentCoverProduct(), [c, requiredSize])) return;
    state.coverColor = c;
    updateTotal();
    buildReview('abReviewList');
  }
  function reviewPickInsertFill(fill) {
    if (fill === state.insertFill) return;
    pickInsertFill(null, fill);
    buildReview('abReviewList');
  }
  function reviewPickInsertLoft(loft) {
    if (loft === state.insertLoft) return;
    pickInsertLoft(null, loft);
    buildReview('abReviewList');
  }

  // Renders one row of choice buttons (a "group") for the edit panel -
  // shared markup for material/fill groups and swatch-style color groups.
  function editOptionGroupHtml(label, options) {
    var html = '<div class="ab-edit-group"><div class="ab-edit-label">' + label + '</div><div class="ab-edit-opts">';
    options.forEach(function (opt) {
      html += '<button type="button" class="ab-edit-opt' + (opt.selected ? ' sel' : '') + '"' + (opt.disabled ? ' disabled' : '') + ' onclick="' + opt.onclick + '">' +
        (opt.swatchClass ? '<span class="ab-edit-swatch-dot ' + opt.swatchClass + '"></span>' : '') +
        '<span class="ab-edit-opt-name">' + opt.name + (opt.disabled ? ' · ' + (opt.disabledReason || 'Sold out') : '') + '</span>' +
        (opt.deltaHtml ? '<span class="ab-edit-delta">' + opt.deltaHtml + '</span>' : '') +
        '</button>';
    });
    html += '</div></div>';
    return html;
  }

  function renderEditPanelHtml(key) {
    if (key === 'sheet') {
      var sheet = currentSheetProduct();
      var sheetVariant = currentSheetVariant();
      var currentPrice = sheetVariant ? sheetVariant.price : 0;

      var fabricOpts = ['percale', 'sateen', 'linen'].map(function (f) {
        var offeredSizes = bedSizesOfferedFor(FABRIC_PRODUCT[f], null);
        var sizeBlocked = !!state.size && offeredSizes.indexOf(state.size) === -1;
        var price = f === state.fabric ? currentPrice : priceForAlternateVariant(FABRIC_PRODUCT[f], [], [state.size], [state.color]);
        return {
          name: FABRIC_NAME[f],
          selected: f === state.fabric,
          disabled: sizeBlocked || !anyVariantAvailable(FABRIC_PRODUCT[f], []),
          disabledReason: sizeBlocked ? ('Only in ' + humanList(offeredSizes)) : 'Sold out',
          deltaHtml: f === state.fabric ? 'Selected' : formatDelta(price - currentPrice),
          onclick: 'SDAlignBuilder.reviewPickFabric(\'' + f + '\')'
        };
      });

      var colorOpts = optionValues(sheet, 'Color').map(function (c) {
        var available = anyVariantAvailable(sheet, [c, state.size]);
        var price = c === state.color ? currentPrice : priceForAlternateVariant(sheet, [c], [state.size], []);
        return {
          name: c,
          swatchClass: 'ab-sw ' + (SWATCH_CLASS[c] || ''),
          selected: c === state.color,
          disabled: !available,
          deltaHtml: c === state.color ? 'Selected' : formatDelta(price - currentPrice),
          onclick: 'SDAlignBuilder.reviewPickColor(\'' + c.replace(/'/g, "\\'") + '\')'
        };
      });

      return '<div class="ab-edit-panel">' + editOptionGroupHtml('Material', fabricOpts) + editOptionGroupHtml('Color', colorOpts) + '</div>';
    }

    if (key === 'cover') {
      var coverVariant = currentCoverVariant();
      var coverCurrentPrice = coverVariant ? coverVariant.price : 0;

      var materialOpts = ['percale', 'sateen', 'boucle', 'waffle'].map(function (m) {
        var offeredSizes = bedSizesOfferedFor(COVER_PRODUCT[m], function (s) { return BED_TO_COMBINED_SIZE[s]; });
        var sizeBlocked = !!state.size && offeredSizes.indexOf(state.size) === -1;
        var price = m === state.coverMaterial ? coverCurrentPrice : priceForAlternateVariant(COVER_PRODUCT[m], [], [state.coverSize], [state.coverColor]);
        return {
          name: COVER_NAME[m],
          selected: m === state.coverMaterial,
          disabled: sizeBlocked || !anyVariantAvailable(COVER_PRODUCT[m], []),
          disabledReason: sizeBlocked ? ('Only in ' + humanList(offeredSizes)) : 'Sold out',
          deltaHtml: m === state.coverMaterial ? 'Selected' : formatDelta(price - coverCurrentPrice),
          onclick: 'SDAlignBuilder.reviewPickCoverMaterial(\'' + m + '\')'
        };
      });

      var coverProduct = currentCoverProduct();
      var coverColorOpts = optionValues(coverProduct, 'Color').map(function (c) {
        var available = requiredCombinedSize() ? anyVariantAvailable(coverProduct, [c, requiredCombinedSize()]) : anyVariantAvailable(coverProduct, [c]);
        var price = c === state.coverColor ? coverCurrentPrice : priceForAlternateVariant(coverProduct, [c], [state.coverSize], []);
        return {
          name: c,
          swatchClass: 'ab-sw ' + (SWATCH_CLASS[c] || ''),
          selected: c === state.coverColor,
          disabled: !available,
          deltaHtml: c === state.coverColor ? 'Selected' : formatDelta(price - coverCurrentPrice),
          onclick: 'SDAlignBuilder.reviewPickCoverColor(\'' + c.replace(/'/g, "\\'") + '\')'
        };
      });

      return '<div class="ab-edit-panel">' + editOptionGroupHtml('Material', materialOpts) + editOptionGroupHtml('Color', coverColorOpts) + '</div>';
    }

    if (key === 'insert') {
      var insertVariant = currentInsertVariant();
      var insertCurrentPrice = insertVariant ? insertVariant.price : 0;

      var fillOpts = optionValues(DUVET_INSERT, 'Fill Material').map(function (fill) {
        var available = requiredCombinedSize() ? anyVariantAvailable(DUVET_INSERT, [fill, requiredCombinedSize()]) : anyVariantAvailable(DUVET_INSERT, [fill]);
        var price = fill === state.insertFill ? insertCurrentPrice : priceForAlternateVariant(DUVET_INSERT, [fill], [state.insertSize], [state.insertLoft]);
        return {
          name: fill,
          selected: fill === state.insertFill,
          disabled: !available,
          deltaHtml: fill === state.insertFill ? 'Selected' : formatDelta(price - insertCurrentPrice),
          onclick: 'SDAlignBuilder.reviewPickInsertFill(\'' + fill.replace(/'/g, "\\'") + '\')'
        };
      });

      var loftOpts = optionValues(DUVET_INSERT, 'Loft').map(function (loft) {
        var available = requiredCombinedSize() ? anyVariantAvailable(DUVET_INSERT, [loft, requiredCombinedSize()]) : anyVariantAvailable(DUVET_INSERT, [loft]);
        var price = loft === state.insertLoft ? insertCurrentPrice : priceForAlternateVariant(DUVET_INSERT, [loft], [state.insertSize], [state.insertFill]);
        return {
          name: loft,
          selected: loft === state.insertLoft,
          disabled: !available,
          deltaHtml: loft === state.insertLoft ? 'Selected' : formatDelta(price - insertCurrentPrice),
          onclick: 'SDAlignBuilder.reviewPickInsertLoft(\'' + loft.replace(/'/g, "\\'") + '\')'
        };
      });

      return '<div class="ab-edit-panel">' + editOptionGroupHtml('Fill', fillOpts) + editOptionGroupHtml('Loft', loftOpts) + '</div>';
    }

    return '';
  }

  // Maps each real variant currently implied by builder state to the step
  // it came from and a function that clears just that step's selection.
  // Used two ways: (1) to recognize which real cart lines are "ours" so
  // they get the Edit affordance and a real image, and (2) so hitting
  // Remove on one of them also clears the matching step - otherwise the
  // next sync would silently re-add whatever was just removed.
  function builderSlotsForState() {
    var slots = [];
    var sheetVariant = currentSheetVariant();
    if (sheetVariant) {
      slots.push({ variantId: sheetVariant.id, editKey: 'sheet', step: 'fabric', clear: function () { state.fabric = null; state.color = null; } });
    }
    if (state.duvet !== 'skip') {
      var cover = currentCoverVariant();
      if (cover) slots.push({ variantId: cover.id, editKey: 'cover', step: 'coverMaterial', clear: function () { state.coverMaterial = null; state.coverColor = null; state.coverSize = null; } });
      if (!state.insertSkipped) {
        var insert = currentInsertVariant();
        if (insert) slots.push({ variantId: insert.id, editKey: 'insert', step: 'insertFill', clear: function () { state.insertFill = null; state.insertLoft = null; state.insertSize = null; state.insertSkipped = false; } });
      }
    }
    if (state.pillows > 0) {
      var pillowVariant = currentPillowVariant();
      if (pillowVariant) slots.push({ variantId: pillowVariant.id, editKey: null, step: 'pillows', clear: function () { state.pillowType = null; state.pillows = 0; } });
    }
    if (state.protector === 'yes') {
      var protectorVariant = currentProtectorVariant();
      if (protectorVariant) slots.push({ variantId: protectorVariant.id, editKey: null, step: 'protector', clear: function () { state.protector = null; } });
    }
    return slots;
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  // Review is a live mirror of the REAL cart, not just a recap of builder
  // state - shows whatever's actually in the cart (including anything a
  // shopper added elsewhere on the site), so quantities/prices/discounts
  // are always exactly what checkout will charge. Builder-picked lines
  // still get their Edit panel; anything else just gets a plain Remove.
  function buildReview(targetId) {
    syncCartToBuilderState().then(fetchCart).then(function (cart) {
      renderReviewFromCart(cart, targetId);
    }).catch(function () {
      // Best-effort - if this fails the shopper still sees whatever was
      // last rendered, and the next state change tries again.
    });
  }

  function reviewLinePriceHtml(originalCents, finalCents) {
    if (originalCents > finalCents) {
      return '<span class="ab-price-orig">' + money(originalCents) + '</span><span class="ab-price-sale">' + money(finalCents) + '</span>';
    }
    return money(finalCents);
  }

  function renderReviewFromCart(cart, targetId) {
    var target = document.getElementById(targetId);
    if (!target) return;
    var slots = builderSlotsForState();

    var html = '';
    cart.items.forEach(function (line) {
      var slot = slots.find(function (s) { return s.variantId === line.variant_id; });
      var editKey = slot ? slot.editKey : null;
      var stepArg = slot ? "'" + slot.step + "'" : 'null';
      var removeOnclick = 'SDAlignBuilder.removeReviewLine(' + line.variant_id + ', ' + stepArg + ')';
      var thumb = line.image ? '<img class="ab-rl-thumb" src="' + line.image + '&width=160" alt="" loading="lazy">' : '<span class="ab-rl-thumb ab-rl-thumb--empty"></span>';
      var desc = line.variant_title && line.variant_title !== 'Default Title' ? line.variant_title : '';

      var qtyStepper = '<div class="ab-qty-sm">' +
        '<button type="button" onclick="SDAlignBuilder.updateReviewQuantity(' + line.variant_id + ', ' + stepArg + ', ' + (line.quantity - 1) + ')">&minus;</button>' +
        '<span class="ab-n">' + line.quantity + '</span>' +
        '<button type="button" onclick="SDAlignBuilder.updateReviewQuantity(' + line.variant_id + ', ' + stepArg + ', ' + (line.quantity + 1) + ')">+</button>' +
        '</div>';

      html += '<div class="ab-rl-item">' + thumb + '<div class="ab-rl-body"><div><div class="ab-rt">' + line.product_title + '</div>' +
        (desc ? '<div class="ab-rd">' + desc + '</div>' : '') +
        '<div class="ab-rl-actions">' + qtyStepper +
        (editKey ? '<button type="button" class="ab-edit" onclick="SDAlignBuilder.toggleReviewEdit(\'' + editKey + '\')">' + (expandedReviewItem === editKey ? 'Done' : 'Edit') + '</button>' : '') +
        '<button type="button" class="ab-remove" onclick="' + removeOnclick + '">Remove</button>' +
        '</div></div><div class="ab-rp">' + money(line.original_line_price) + '</div></div></div>';

      if (editKey && expandedReviewItem === editKey) {
        html += renderEditPanelHtml(editKey);
      }
    });

    if (!cart.items.length) {
      html += '<div class="ab-rl-item"><div class="ab-rd">Your cart is empty.</div></div>';
    }

    // Uses the real cart's own before/after total (not a local estimate) -
    // shows plain when nothing's discounted, strikethrough if a real
    // discount code/automatic discount is actually applied at checkout.
    html += '<div class="ab-rl-item"><div class="ab-rt">Total <span style="font-weight:300;color:var(--ab-muted);font-size:12px;">(+ tax, free shipping)</span></div><div class="ab-rp" style="font-weight:600;">' + reviewLinePriceHtml(cart.original_total_price, cart.total_price) + '</div></div>';
    target.innerHTML = html;

    // The footer total mirrors the REAL cart from here on (not the local
    // build-only total updateTotal() computes) - if the shopper already
    // had something else in their cart before starting the builder, the
    // footer at checkout time needs to match what they're actually about
    // to pay, not just this build's price.
    var totalEl = document.getElementById('abTotalVal');
    if (totalEl) totalEl.innerHTML = money(cart.total_price) + ' <small>+ tax</small>';

    var cont = document.getElementById('abContBtn');
    if (cont) cont.toggleAttribute('disabled', cart.items.length === 0);
  }

  // Keeps builder state's own quantity field in sync with a manual change
  // made via the Review page's stepper - without this, the very next
  // syncCartToBuilderState() call would reset the line right back to
  // whatever quantity the builder itself assumes (1, or state.pillows).
  function setSlotQuantity(step, qty) {
    switch (step) {
      case 'fabric': state.sheetQty = qty; break;
      case 'coverMaterial': state.coverQty = qty; break;
      case 'insertFill': state.insertQty = qty; break;
      case 'pillows': state.pillows = qty; break;
      case 'protector': state.protectorQty = qty; break;
    }
  }

  // Quantity stepper on the Review page - works for builder-picked lines
  // and anything else in the cart alike. Dropping to 0 is just a Remove.
  function updateReviewQuantity(variantId, step, newQty) {
    if (newQty <= 0) { removeReviewLine(variantId, step); return; }
    newQty = Math.min(newQty, 10);
    if (step) setSlotQuantity(step, newQty);
    var updates = {};
    updates[variantId] = newQty;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () {
      updateTotal();
      buildReview('abReviewList');
    });
  }

  // Removes one line directly from the real cart. If it was a builder-
  // picked piece (sheet/cover/insert/pillows/protector), also clears that
  // step's selection so the next sync doesn't silently add it right back.
  function removeReviewLine(variantId, step) {
    if (step) {
      var slot = builderSlotsForState().find(function (s) { return s.step === step; });
      if (slot) slot.clear();
    }
    var updates = {};
    updates[variantId] = 0;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () {
      updateTotal();
      buildReview('abReviewList');
    });
  }

  // ---------- checkout ----------
  function collectCartItems() {
    var items = [];
    var sheetVariant = currentSheetVariant();
    if (sheetVariant) items.push({ id: sheetVariant.id, quantity: state.sheetQty });
    if (state.duvet !== 'skip') {
      var cover = currentCoverVariant();
      if (cover) items.push({ id: cover.id, quantity: state.coverQty });
      if (!state.insertSkipped) {
        var insert = currentInsertVariant();
        if (insert) items.push({ id: insert.id, quantity: state.insertQty });
      }
    }
    if (state.pillows > 0) {
      var pillowVariant = currentPillowVariant();
      if (pillowVariant) items.push({ id: pillowVariant.id, quantity: state.pillows });
    }
    if (state.protector === 'yes') {
      var protectorVariant = currentProtectorVariant();
      if (protectorVariant) items.push({ id: protectorVariant.id, quantity: state.protectorQty });
    }
    return items;
  }

  // Tracks which variant IDs we've put into the REAL Shopify cart via
  // syncCartToBuilderState(), so a later sync knows which lines are now
  // stale (the shopper edited that choice away) vs. still current -
  // without ever touching anything already in their cart from elsewhere.
  var cartSyncedVariantIds = [];

  // Keeps the real Shopify cart in sync with the builder's current
  // selection, live, from the moment the shopper reaches Review - not held
  // back for the final Checkout click. That way ad-pixel "Add to Cart"
  // events and abandoned-checkout email flows fire off a real cart, and
  // anyone who closes the builder here still has a normal cart to return
  // to. Uses the bulk /cart/update.js endpoint so removing stale lines and
  // adding/updating current ones happens in a single call.
  function syncCartToBuilderState() {
    var desired = collectCartItems();
    var updates = {};
    cartSyncedVariantIds.forEach(function (id) {
      if (!desired.some(function (it) { return it.id === id; })) updates[id] = 0;
    });
    desired.forEach(function (it) { updates[it.id] = it.quantity; });
    if (!Object.keys(updates).length) return Promise.resolve();

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      if (res.ok) cartSyncedVariantIds = desired.map(function (it) { return it.id; });
    }).catch(function () {
      // Best-effort - the final Checkout click below re-syncs once more
      // before redirecting, so a transient failure here isn't fatal.
    });
  }

  // ---------- skip buttons (Cover Material / Insert Fill) ----------
  // Both jump straight to Review (the step with the email signup form,
  // trust badges, and real cart total) rather than redirecting off the
  // builder entirely - Review's own buildReview() call (inside showStep())
  // is what actually syncs the real cart, same as reaching it normally.
  function skipSheetsOnly() {
    state.duvet = 'skip';
    state.coverMaterial = null; state.coverColor = null; state.coverSize = null;
    state.insertFill = null; state.insertLoft = null; state.insertSize = null;
    state.insertSkipped = false;
    goToStep('review');
  }
  function skipInsertOnly() {
    state.insertFill = null; state.insertLoft = null; state.insertSize = null;
    state.insertSkipped = true;
    goToStep('review');
  }

  // By the time this runs, the real cart already matches the builder
  // (kept live via syncCartToBuilderState() above) - this just does one
  // last sync to catch anything still in flight, then goes straight to
  // checkout instead of re-submitting a redundant /cart/add.
  function placeOrder() {
    var cont = document.getElementById('abContBtn');
    cont.setAttribute('disabled', 'disabled');
    cont.textContent = 'Heading to checkout!';

    syncCartToBuilderState().then(function () {
      window.location.href = '/checkout';
    });
  }

  window.SDAlignBuilder = {
    open: openBuilder,
    close: closeBuilder,
    next: nextStep,
    prev: prevStep,
    goToStep: goToStep,
    pickFabric: pickFabric,
    pickOpt: pickOpt,
    pickDuvet: pickDuvet,
    pickCoverMaterial: pickCoverMaterial,
    pickInsertFill: pickInsertFill,
    pickInsertLoft: pickInsertLoft,
    skipSheetsOnly: skipSheetsOnly,
    skipInsertOnly: skipInsertOnly,
    pickPillowType: pickPillowType,
    changePillows: changePillows,
    toggleReviewEdit: toggleReviewEdit,
    reviewPickFabric: reviewPickFabric,
    reviewPickColor: reviewPickColor,
    reviewPickCoverMaterial: reviewPickCoverMaterial,
    reviewPickCoverColor: reviewPickCoverColor,
    reviewPickInsertFill: reviewPickInsertFill,
    reviewPickInsertLoft: reviewPickInsertLoft,
    removeReviewLine: removeReviewLine,
    updateReviewQuantity: updateReviewQuantity
  };

  // Start warming the cache immediately on page load - while the shopper is
  // still reading the landing page (hero / how it works / materials) is
  // free time to have the first steps' photos ready before "Build Your
  // Bed" is even clicked. This only primes the image cache - nothing here
  // touches `state`, since nothing is pre-selected.
  preloadFirstImagePerValue(FABRIC_PRODUCT.sateen, 'color', optionValues(FABRIC_PRODUCT.sateen, 'Color'));
  preloadFullGalleryFor('fabric');
  preloadFirstImagePerValue(FABRIC_PRODUCT.linen, 'color', optionValues(FABRIC_PRODUCT.linen, 'Color'));
  preloadFirstImagePerValue(FABRIC_PRODUCT.percale, 'color', optionValues(FABRIC_PRODUCT.percale, 'Color'));
  // Protector's gallery is a fixed single-color set (not user-selectable),
  // so it's always the same images - safe to warm up immediately rather
  // than waiting for the shopper to reach that step near the end.
  preloadFullGalleryFor('protector');

  // Deep link support: a URL like /pages/align-system-build?open=builder
  // launches the builder immediately on load, skipping the landing-page
  // click - lets ad traffic land straight in the flow instead of on the
  // landing page first.
  if (new URLSearchParams(window.location.search).get('open') === 'builder') {
    openBuilder();
  }

  // Sticky CTA only appears once the hero's own "Build Your Bed" button
  // has scrolled out of view - not a permanently-visible bar. Builder-open
  // state already hides it separately via .ab-builder-open in the CSS.
  var heroCta = document.getElementById('abHeroCta');
  var stickyCta = document.getElementById('abStickyCta');
  if (heroCta && stickyCta && 'IntersectionObserver' in window) {
    var heroCtaObserver = new IntersectionObserver(function (entries) {
      stickyCta.classList.toggle('is-visible', !entries[0].isIntersecting);
    });
    heroCtaObserver.observe(heroCta);
  }
})();
